import { Flame, Star, Moon } from "lucide-react";

const poojasStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Cinzel+Decorative:wght@400;700;900&family=Cinzel:wght@400;600;700&family=Noto+Serif:ital,wght@0,400;0,600;1,400&display=swap');

  .poojas-section {
    position: relative;
    background: #FFF8E7;
    padding: 5rem 2rem;
    overflow: hidden;
  }

  /* subtle star pattern bg */
  .poojas-section::before {
    content: '';
    position: absolute; inset: 0;
    background-image: url("data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23C9920A' fill-opacity='0.045'%3E%3Cpath d='M40 0l3 37H80L50 60l11 37-21-16-21 16 11-37L0 37h37z'/%3E%3C/g%3E%3C/svg%3E");
    background-size: 80px 80px;
    pointer-events: none;
  }

  .poojas-inner {
    max-width: 1150px;
    margin: 0 auto;
    position: relative; z-index: 1;
  }

  /* Header */
  .poojas-header {
    text-align: center;
    margin-bottom: 4rem;
  }

  .poojas-eyebrow {
    font-family: 'Cinzel', serif;
    font-size: 0.7rem; font-weight: 600;
    letter-spacing: 0.3em; text-transform: uppercase;
    color: #C9920A; margin-bottom: 0.75rem;
    display: flex; align-items: center; justify-content: center; gap: 12px;
  }

  .poojas-eyebrow::before,
  .poojas-eyebrow::after {
    content: ''; height: 1px; width: 50px;
    background: linear-gradient(90deg, transparent, #C9920A);
  }
  .poojas-eyebrow::after {
    background: linear-gradient(90deg, #C9920A, transparent);
  }

  .poojas-title {
    font-family: 'Cinzel Decorative', serif;
    font-size: 2rem; font-weight: 700;
    color: #8B0000;
    text-shadow: 1px 2px 8px rgba(139,0,0,0.12);
    margin-bottom: 1rem;
  }

  .poojas-ornament {
    display: flex; align-items: center; justify-content: center; gap: 12px;
    color: #C9920A; font-size: 1.1rem; letter-spacing: 0.5em;
  }

  .poojas-ornament::before,
  .poojas-ornament::after {
    content: ''; height: 1px; width: 80px;
    background: linear-gradient(90deg, transparent, #C9920A, transparent);
  }

  /* Cards Grid */
  .poojas-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
  }

  .pooja-card {
    background: #fff;
    border: 1px solid rgba(201,146,10,0.18);
    border-radius: 6px;
    padding: 2.25rem 1.75rem;
    position: relative;
    overflow: hidden;
    transition: all 0.35s cubic-bezier(0.4,0,0.2,1);
    box-shadow: 0 2px 16px rgba(139,0,0,0.05);
  }

  /* top accent bar */
  .pooja-card::before {
    content: '';
    position: absolute; top: 0; left: 0; right: 0; height: 3px;
    background: linear-gradient(90deg, #8B0000, #C9920A, #F0C040);
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.4s ease;
  }

  /* warm glow on hover */
  .pooja-card::after {
    content: '';
    position: absolute; inset: 0;
    background: linear-gradient(135deg, rgba(139,0,0,0.03), rgba(201,146,10,0.06));
    opacity: 0; transition: opacity 0.35s;
    pointer-events: none;
  }

  .pooja-card:hover {
    transform: translateY(-6px);
    border-color: rgba(201,146,10,0.4);
    box-shadow: 0 16px 48px rgba(139,0,0,0.12);
  }

  .pooja-card:hover::before { transform: scaleX(1); }
  .pooja-card:hover::after { opacity: 1; }

  /* Icon circle */
  .pooja-icon-wrap {
    width: 60px; height: 60px;
    border-radius: 50%;
    background: linear-gradient(135deg, rgba(139,0,0,0.08), rgba(201,146,10,0.12));
    border: 1.5px solid rgba(201,146,10,0.3);
    display: flex; align-items: center; justify-content: center;
    margin-bottom: 1.5rem;
    transition: all 0.3s;
  }

  .pooja-card:hover .pooja-icon-wrap {
    background: linear-gradient(135deg, rgba(139,0,0,0.15), rgba(201,146,10,0.2));
    border-color: #C9920A;
    box-shadow: 0 0 16px rgba(201,146,10,0.25);
  }

  .pooja-card-title {
    font-family: 'Cinzel', serif;
    font-size: 1.05rem; font-weight: 700;
    color: #8B0000; margin-bottom: 0.85rem;
    letter-spacing: 0.03em;
  }

  .pooja-divider {
    width: 36px; height: 2px;
    background: linear-gradient(90deg, #C9920A, #F0C040);
    margin-bottom: 1rem;
    transition: width 0.3s;
    border-radius: 2px;
  }

  .pooja-card:hover .pooja-divider { width: 60px; }

  .pooja-card-text {
    font-family: 'Noto Serif', serif;
    font-size: 0.97rem; line-height: 1.8;
    color: #4a2e10;
  }

  /* Highlight tag */
  .pooja-tag {
    display: inline-block;
    font-family: 'Cinzel', serif;
    font-size: 0.62rem; font-weight: 700;
    letter-spacing: 0.12em; text-transform: uppercase;
    color: #C9920A;
    background: rgba(201,146,10,0.1);
    border: 1px solid rgba(201,146,10,0.25);
    padding: 3px 10px; border-radius: 2px;
    margin-top: 1.1rem;
  }

  /* Bottom decorative border */
  .poojas-footer {
    text-align: center;
    margin-top: 3.5rem;
    padding-top: 2.5rem;
    border-top: 1px solid rgba(201,146,10,0.2);
  }

  .poojas-footer p {
    font-family: 'Noto Serif', serif;
    font-style: italic;
    font-size: 1rem; color: #7a4a1a;
    letter-spacing: 0.02em;
  }

  .poojas-footer span { color: #C9920A; font-style: normal; }

  @media (max-width: 768px) {
    .poojas-grid { grid-template-columns: 1fr; }
    .poojas-title { font-size: 1.6rem; }
  }
`;

const poojas = [
  {
    icon: Flame,
    title: "Every Tuesday",
    text: "Guru Homam, Worship Ghee Vilakku Pooja, and Annadhanam at 12:00 Noon.",
    tag: "Weekly",
  },
  {
    icon: Star,
    title: "Monthly Star Poojas",
    text: "Special Pooja conducted on Sadhayam and Anusham star days every month.",
    tag: "Monthly",
  },
  {
    icon: Moon,
    title: "Pournami & Amavasai",
    text: "Special Abishekam, Pooja, and Prasadam will be offered on these sacred days.",
    tag: "Sacred Days",
  },
];

const SpecialPoojas = () => (
  <>
    <style>{poojasStyles}</style>
    <section className="poojas-section" id="poojas">
      <div className="poojas-inner">

        <div className="poojas-header">
          <p className="poojas-eyebrow">Rituals & Offerings</p>
          <h2 className="poojas-title">Special & Monthly Poojas</h2>
          <div className="poojas-ornament">✦ ✦ ✦</div>
        </div>

        <div className="poojas-grid">
          {poojas.map(({ icon: Icon, title, text, tag }) => (
            <div className="pooja-card" key={title}>
              <div className="pooja-icon-wrap">
                <Icon size={26} color="#8B0000" strokeWidth={1.8} />
              </div>
              <h3 className="pooja-card-title">{title}</h3>
              <div className="pooja-divider" />
              <p className="pooja-card-text">{text}</p>
              <span className="pooja-tag">{tag}</span>
            </div>
          ))}
        </div>

        <div className="poojas-footer">
          <p>
            For pooja bookings &amp; enquiries, call us at{" "}
            <span>+91 94433 13744</span>
          </p>
        </div>

      </div>
    </section>
  </>
);

export default SpecialPoojas;